<div class="pa-popup" [hidden]="!isDisplayed" [ngStyle]="style">
    <div class="pa-popup-wrapper">
        <ng-content></ng-content>
    </div>
</div>
